// extracted by mini-css-extract-plugin
module.exports = {"update-required-modal":"Uf6ji8slUKpqdyvTMi_D6","update-required-modal-dialog":"_24uBzMZ8hLqgAIPmZUuw7g","btn-action":"_1cduNkSOEHfvMc4K4OlZ02"};